import { BALANCE_CONSUMED_API } from "../../constants/constants"
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor"
import { TopConsumedCustomersSuccess, TopConsumedCustomersFailure } from "./reducer"

export const TopConsumedCustomers = (setLoading) => async (dispatch) => {
    setLoading(true)
    const graphqlQuery = {
        query: "query TopConsumedCustomers($limit: Int) {\n  TopConsumedCustomers(limit: $limit) {\n    customerId\n    customerName\n    totalConsumed\n  }\n}",
        variables: { limit: 4 },
    }

    try {
        const response = await determineBaseUrlAndPerformApiCall(
            `${BALANCE_CONSUMED_API}`,
            'POST',
            graphqlQuery
        );
        setLoading(true)
        const TopConsumedCustomers = response?.data?.TopConsumedCustomers
        dispatch(TopConsumedCustomersSuccess(TopConsumedCustomers))
    } catch (error) {
        dispatch(TopConsumedCustomersFailure(error.message))
    } finally {
        setLoading(false)
    }
}

